import SliderField from './SliderField';

export default SliderField;
